'use client'

import { TransitionStartFunction, createContext, useContext } from 'react'
import { UseFormTrigger } from 'react-hook-form'

type FormFooterContext = {
  formTrigger?: UseFormTrigger<any>
  isPending: boolean
  startTransition: TransitionStartFunction
}

export const FormFooterContext = createContext<FormFooterContext | undefined>(
  undefined
)

export function useFormFooterContext(): FormFooterContext {
  const context = useContext(FormFooterContext)

  if (!context) {
    throw new Error(
      'useFormFooterContext should be used within the FormFooterContext provider!'
    )
  }

  return context
}
